/**
 * @description
 * Mobile phone formatter 0XXX XXX XXX (10 digits)
 */
export const formatMobile = (value: string) => {
  const trimmedValue = value.replace(/\s/g, '');
  return trimmedValue.length === 10
    ? trimmedValue.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3')
    : value;
};

/**
 * @description
 * 6 digit phone number formatter XXX XXX
 */
export const formatSixDigitPhone = (value: string) => {
  const trimmedValue = value.replace(/\s/g, '');
  return trimmedValue.length === 6 ? trimmedValue.replace(/(\d{3})(\d{3})/, '$1 $2') : value;
};
